export const getFaqSectionIndexData = async (culture) => {
    try {
        const response = await fetch(`/api/faq/index?culture=${culture}`, {
            method: 'GET',
        });
        return await response.json();
    } catch (error) {
        console.warn('Error fetching faq section index data: ', error);
    }
};

export const getFaqSectionDocData = async (questionId, culture) => {
    try {
        const response = await fetch(`/api/faq/doc/${questionId}?culture=${culture}`, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.text();
    } catch (error) {
        console.warn('Error fetching faq section doc data: ', error);
    }
};
